module.exports = __webpack_public_path__ + "images/83c59e8c7ed71c4cdd9928179b6da857.svg";